import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

import MaskedInput from 'react-text-mask'

const PhoneCustomFieldValue = ({
  team,
  csrfToken,
  confirm,
  customFieldValue,
  customFieldValueChanged,
  highlightInvalidInputs=false
}) => (
  <div className="col-6">
    <MaskedInput  className={`form-control ${(customFieldValue.value?.length != 14 && customFieldValue.custom_field.required && highlightInvalidInputs) ? "highlight" : ""}`}
                  style={{"border": "1px solid var(--od-c-e6e6e6, #e6e6e6)", "fontSize": "14px"}}
                  placeholder={customFieldValue.custom_field.name + (customFieldValue.custom_field.required ? " (required)" : " (optional)")}
                  guide={false}
                  onChange={
                    (e) => {
                      var updated = Object.assign({}, customFieldValue, {value: e.target.value});
                      customFieldValueChanged(updated);
                    }
                  }
                  value={customFieldValue.value || ""}
                  mask={['(',/[1-9]/,/\d/,/\d/,')',' ',/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/]} />
  </div>
);

PhoneCustomFieldValue.propTypes = {
  team: PropTypes.object,
  csrfToken: PropTypes.string,
  confirm: PropTypes.object,
  customFieldValue: PropTypes.object.isRequired,
  customFieldValueChanged: PropTypes.func.isRequired,
  highlightInvalidInputs: PropTypes.bool
};

export default PhoneCustomFieldValue;
